module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-engagements-icon-packs-bio.998e6979.svg";